import React, { useState, useEffect } from 'react';
import logo from '../assets/logo.png';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => { setMenuOpen(false); document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }); };

  const links = [
    { label: 'Home', id: 'home' },
    { label: 'About', id: 'about' },
    { label: 'Services', id: 'services' },
    { label: 'Industries', id: 'industries' },
    { label: 'Clients', id: 'clients' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <>
      {/* Top bar */}
      <div className="topbar">
        <div className="container topbar-inner">
          <span>📍Chakan, Pune, Maharashtra</span>
          <span>📞 <a href="tel:+919689100663" style={{color:'inherit',textDecoration:'none'}}>+91 96891 00663</a> &nbsp;|&nbsp; <a href="tel:+919767577713" style={{color:'inherit',textDecoration:'none'}}>+91 97675 77713</a></span>
        </div>
      </div>

      {/* Main nav */}
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="container nav-inner">
          <button className="logo-wrap" onClick={() => scrollTo('home')}>
            <img src={logo} alt="SSM Logo" className="logo-img" />
            <div className="logo-text">
              <div className="l1">Shri Sai Manpower Services</div>
              <div className="l2">SSM Services · Est. 2017</div>
            </div>
          </button>

          <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
            {links.map(l => (
              <button key={l.id} className="nav-link" onClick={() => scrollTo(l.id)}>{l.label}</button>
            ))}
          </div>

          <div className="nav-actions">
            <a href="https://wa.me/919689100663" className="btn-wa" target="_blank" rel="noreferrer">💬 WhatsApp</a>
            <a href="tel:+919689100663" className="btn-red-nav">📞 Call Now</a>
          </div>

          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>{menuOpen ? '✕' : '☰'}</button>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
